// third-party
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project imports

// types
import { ContentProvidersProps, DefaultRootStateProps } from 'types';
import axios from 'utils/axios';
import { openSnackbar } from './snackbar';
import { RejectedActionFromAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import { IcecatObjectType } from 'types/contentProviders';

const initialState: DefaultRootStateProps['contentProviders'] = {
    loadingGetIcecatInfo: true,
    icecatInfo: undefined,
    error: null
};

const slice = createSlice({
    name: 'contenProviders',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getIcecatInfo.pending, (state) => {
                state.loadingGetIcecatInfo = true;
            })
            .addCase(getIcecatInfo.fulfilled, (state, action) => {
                const newInfo: Record<any, any> = {};

                const data = action.payload || {};

                Object.entries(data).forEach(([key, val]) => {
                    if (key === 'GeneralInfo') {
                        const value = val as Record<string, any>;

                        const generalInfo: IcecatObjectType['generalInfo'] = {
                            description: value?.SummaryDescription?.LongSummaryDescription,
                            shortDescription: value?.SummaryDescription?.LongSummaryDescription,
                            productName: value?.ProductName,
                            title: value?.Title
                        };

                        newInfo.generalInfo = generalInfo;
                    }
                    if (key === 'Gallery') {
                        const value = val as Record<string, any>[];

                        const gallery: IcecatObjectType['gallery'] = (value ?? [])?.map((item) => {
                            return { id: item.ID, url: item.Pic, size: Number(item.Size), type: item.Type, isMain: item.IsMain === 'Y' };
                        });

                        newInfo.gallery = gallery;
                    }

                    if (key === 'Multimedia') {
                        const value = val as Record<string, any>[];

                        const media: IcecatObjectType['multimedia'] = (value ?? [])?.map((item) => {
                            return {
                                id: item.ID,
                                url: item.URL,
                                size: Number(item.Size),
                                ContentType: item.ContentType,
                                isVideo: Boolean(item.IsVideo),
                                language: item.Language,
                                description: item.Description
                            };
                        });

                        newInfo.multimedia = media;
                    }
                });

                const hasValues = Boolean(Object.values(newInfo).find((item) => item));

                state.icecatInfo = hasValues ? (newInfo as IcecatObjectType) : undefined;

                state.loadingGetIcecatInfo = false;
            });

        // TODO: Migrate vademecum info

        // AUTO catch errors
        builder.addMatcher<RejectedActionFromAsyncThunk<any>>(
            (action) => action.type.endsWith('/rejected'),
            (state, action) => {
                const thunkName = action.type.split('/')[0];
                const loadingProperty = `loading${thunkName.charAt(0).toUpperCase()}${thunkName.slice(1)}` as keyof ContentProvidersProps;

                if (loadingProperty in state) {
                    (state as any)[loadingProperty] = false;
                }

                state.error = action.error.message ?? 'Unknown error';
            }
        );
    }
});

export default slice.reducer;

export const getIcecatInfo = createAsyncThunk(`${slice.name}/getIcecatInfo`, async (ean: string | number, { dispatch }) => {
    try {
        const response = await axios.get(`loolu/api/contentProviders/iceCat`, {
            params: { ean }
        });

        return response.data.data;
    } catch (error) {
        dispatch(
            openSnackbar({
                message: `An error occurred while fetching Vademecum info`,
                variant: 'error'
            })
        );
    }
});
